import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isDefinedAndNotEmpty, isEmpty } from 'check-tool';
import { Link } from 'react-router-dom';
import { AuthContext } from 'AuthProvider';

import { storage } from '../../firebase';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import Select from 'components/Select';
import AnswerItem from 'pages/QuestionsPage/AnswerItem';

import { getCategoriesList } from 'backend/Category';
import { getSubcategoriesList } from 'backend/Subcategory';
import { getQuestionItem, updateQuestion, updateQuestionImage } from 'backend/Question';
import { getAnswersListById, createAnswer } from 'backend/Answer';

const QuestionPage = (props) => {
  const [isEditQuestion, setIsEditQuestion] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [question, setQuestion] = useState({});

  const [categoryUid, setCategoryUid] = useState('all');
  const [categoryName, setCategoryName] = useState('');
  const [subcategoryUid, setSubcategoryUid] = useState('all');
  const [subcategoryName, setSubcategoryName] = useState('');
  const [typeImage, setTypeImage] = useState('');

  const [answerNameEn, setAnswerNameEn] = useState('');
  const [answerNameRu, setAnswerNameRu] = useState('');
  const [answerNameUk, setAnswerNameUk] = useState('');
  const [answerNamePl, setAnswerNamePl] = useState('');
  const [answerNameIt, setAnswerNameIt] = useState('');
  const [answerNameEs, setAnswerNameEs] = useState('');
  const [answerNamePt, setAnswerNamePt] = useState('');

  const [questionNameEn, setQuestionNameEn] = useState('');
  const [questionNameRu, setQuestionNameRu] = useState('');
  const [questionNameUk, setQuestionNameUk] = useState('');
  const [questionNamePl, setQuestionNamePl] = useState('');
  const [questionNameIt, setQuestionNameIt] = useState('');
  const [questionNameEs, setQuestionNameEs] = useState('');
  const [questionNamePt, setQuestionNamePt] = useState('');

  const [questionLocalNameEn, setQuestionLocalNameEn] = useState('');
  const [questionLocalNameRu, setQuestionLocalNameRu] = useState('');
  const [questionLocalNameUk, setQuestionLocalNameUk] = useState('');
  const [questionLocalNamePl, setQuestionLocalNamePl] = useState('');
  const [questionLocalNameIt, setQuestionLocalNameIt] = useState('');
  const [questionLocalNameEs, setQuestionLocalNameEs] = useState('');
  const [questionLocalNamePt, setQuestionLocalNamePt] = useState('');

  const [questionLeadEn, setQuestionLeadEn] = useState('');
  const [questionLeadRu, setQuestionLeadRu] = useState('');
  const [questionLeadUk, setQuestionLeadUk] = useState('');
  const [questionLeadPl, setQuestionLeadPl] = useState('');
  const [questionLeadIt, setQuestionLeadIt] = useState('');
  const [questionLeadEs, setQuestionLeadEs] = useState('');
  const [questionLeadPt, setQuestionLeadPt] = useState('');

  const [questionLocalLeadEn, setQuestionLocalLeadEn] = useState('');
  const [questionLocalLeadRu, setQuestionLocalLeadRu] = useState('');
  const [questionLocalLeadUk, setQuestionLocalLeadUk] = useState('');
  const [questionLocalLeadPl, setQuestionLocalLeadPl] = useState('');
  const [questionLocalLeadIt, setQuestionLocalLeadIt] = useState('');
  const [questionLocalLeadEs, setQuestionLocalLeadEs] = useState('');
  const [questionLocalLeadPt, setQuestionLocalLeadPt] = useState('');

  const [image, setImage] = useState(null);
  const [url, setUrl] = useState(question.image);
  const [progress, setProgress] = useState(0);

  const [answers, setAnswers] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const { id } = props.match.params;
  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);

  const typeImageArr = [
    {alias: 'question', name: {ru: 'отображать в вопросе'}},
    {alias: 'answer', name: {ru: 'отображать в ответе'}}
  ];

  useEffect(() => {
    if (categories.length === 0) {
      getCategoriesList()
      .then((result) => {
        setCategories(result);
      })
      .catch((error) => {
        console.log('error', error);
        setCategories([]);
      });
    }
  }, [categories.length]);

  useEffect(() => {
    if (subcategories.length === 0) {
      getSubcategoriesList()
        .then((result) => {
          setSubcategories(result);
        })
        .catch((error) => {
          console.log('error', error);
          setSubcategories([]);
        });
    }
  }, []);

  useEffect(() => {
    if (isDefinedAndNotEmpty(id)) {
      getQuestionItem(id)
        .then((result) => {
          setQuestion(result);
        })
        .catch((error) => {
          console.log('error', error);
          setQuestion({});
        });

      //Get answers
      getAnswersListById(id)
        .then((result) => {
          setAnswers(result);
        })
        .catch((error) => {
            console.log('error getAnswersListById', error);
            setAnswers([]);
        });
    }
  }, []);

  useEffect(() => {
    setUrl(question.image);
    setTypeImage(question.typeImage);
    if (isDefinedAndNotEmpty(question.categoryUid)) {
      setCategoryUid(question.categoryUid);
      const item = categories.find((x) => x.alias === question.categoryUid);
      setCategoryName(item.name.ru);
    }
    if (isDefinedAndNotEmpty(question.subcategoryUid)) {
      setSubcategoryUid(question.subcategoryUid);
      const itemSubcategory = subcategories.find((x) => x.alias === question.subcategoryUid);
      setSubcategoryName(itemSubcategory.name.ru);
    }
    if (isDefinedAndNotEmpty(question.name)) {
      setQuestionNameEn(question.name.en);
      setQuestionLocalNameEn(question.name.en);
      setQuestionNameRu(question.name.ru);
      setQuestionLocalNameRu(question.name.ru);
      setQuestionNameUk(question.name.uk);
      setQuestionLocalNameUk(question.name.uk);
      setQuestionNamePl(question.name.pl);
      setQuestionLocalNamePl(question.name.pl);
      setQuestionNameIt(question.name.it);
      setQuestionLocalNameIt(question.name.it);
      setQuestionNameEs(question.name.es);
      setQuestionLocalNameEs(question.name.es);
      setQuestionNamePt(question.name.pt);
      setQuestionLocalNamePt(question.name.pt);
    }

    if (isDefinedAndNotEmpty(question.lead)) {
      setQuestionLeadEn(question.lead.en);
      setQuestionLocalLeadEn(question.lead.en);
      setQuestionLeadRu(question.lead.ru);
      setQuestionLocalLeadRu(question.lead.ru);
      setQuestionLeadUk(question.lead.uk);
      setQuestionLocalLeadUk(question.lead.uk);
      setQuestionLeadPl(question.lead.pl);
      setQuestionLocalLeadPl(question.lead.pl);
      setQuestionLeadIt(question.lead.it);
      setQuestionLocalLeadIt(question.lead.it);
      setQuestionLeadEs(question.lead.es);
      setQuestionLocalLeadEs(question.lead.es);
      setQuestionLeadPt(question.lead.pt);
      setQuestionLocalLeadPt(question.lead.pt);
    }
  }, [question]);

  useEffect(() => {
    let arr = [];
    subcategories.map((element) => {
      if (element.categoryUid === categoryUid) {
        arr.push(element);
      }
    });
  
    setSelectedSubcategories(arr);
  }, [categoryUid, categories]);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const onClickDelete = () => {
    alert('TODO: step 2');
  };

  const onClickEdit = () => {
    setIsEditQuestion(!isEditQuestion);
  };

  const onClickSave = () => {
    setProgress(0);
    if (isDefinedAndNotEmpty(categoryUid) && isDefinedAndNotEmpty(subcategoryUid) && subcategoryUid !== 'all') {
      updateQuestion(
        id,
        categoryUid,
        subcategoryUid,
        questionNameEn,
        questionNameRu,
        questionNameUk,
        questionNamePl,
        questionNameIt,
        questionNameEs,
        questionNamePt,
        questionLeadEn,
        questionLeadRu,
        questionLeadUk,
        questionLeadPl,
        questionLeadIt,
        questionLeadEs,
        questionLeadPt,
        typeImage,
      )
      .then(() => {
        setIsEditQuestion(false);
        const item = categories.find((x) => x.alias === categoryUid);
        setCategoryName(item.name.ru);
        const itemSubcategory = subcategories.find((x) => x.alias === subcategoryUid);
        setSubcategoryName(itemSubcategory.name.ru);

        setQuestionLocalNameEn(questionNameEn);
        setQuestionLocalLeadEn(questionLeadEn);
        setQuestionLocalNameRu(questionNameRu);
        setQuestionLocalLeadRu(questionLeadRu);
        setQuestionLocalNameUk(questionNameUk);
        setQuestionLocalLeadUk(questionLeadUk);
        setQuestionLocalNamePl(questionNamePl);
        setQuestionLocalLeadPl(questionLeadPl);
        setQuestionLocalNameIt(questionNameIt);
        setQuestionLocalLeadIt(questionLeadIt);
        setQuestionLocalNameEs(questionNameEs);
        setQuestionLocalLeadEs(questionLeadEs);
        setQuestionLocalNamePt(questionNamePt);
        setQuestionLocalLeadPt(questionLeadPt);
      })
      .catch((error) => {
        console.log('updateQuestion error', error);
      });
    } else {
      alert('Категория и подкатегория должны быть выбраны');
    }
  };

  const onClickCancel = () => {
    setIsEditQuestion(false);
    setCategoryUid(categoryUid);
    const item = categories.find((x) => x.alias === categoryUid);
    setCategoryName(item.name.ru);

    setSubcategoryUid(subcategoryUid);
    const itemSubcategory = subcategories.find((x) => x.alias === subcategoryUid);
    setSubcategoryName(itemSubcategory.name.ru);

    setQuestionNameEn(questionLocalNameEn);
    setQuestionLeadEn(questionLocalLeadEn);
    setQuestionNameRu(questionLocalNameRu);
    setQuestionLeadRu(questionLocalLeadRu);
    setQuestionNameUk(questionLocalNameUk);
    setQuestionLeadUk(questionLocalLeadUk);
    setQuestionNamePl(questionLocalNamePl);
    setQuestionLeadPl(questionLocalLeadPl);
    setQuestionNameIt(questionLocalNameIt);
    setQuestionLeadIt(questionLocalLeadIt);
    setQuestionNameEs(questionLocalNameEs);
    setQuestionLeadEs(questionLocalLeadEs);
    setQuestionNamePt(questionLocalNamePt);
    setQuestionLeadPt(questionLocalLeadPt);
    
    setProgress(0);
  };

  const onChangeText = (event, field) => {
    if (field === 'answerNameEn') setAnswerNameEn(event.target.value);
    if (field === 'answerNameRu') setAnswerNameRu(event.target.value);
    if (field === 'answerNameUk') setAnswerNameUk(event.target.value);
    if (field === 'answerNamePl') setAnswerNamePl(event.target.value);
    if (field === 'answerNameIt') setAnswerNameIt(event.target.value);
    if (field === 'answerNameEs') setAnswerNameEs(event.target.value);
    if (field === 'answerNamePt') setAnswerNamePt(event.target.value);

    if (field === 'nameEn') setQuestionNameEn(event.target.value);
    if (field === 'nameRu') setQuestionNameRu(event.target.value);
    if (field === 'nameUk') setQuestionNameUk(event.target.value);
    if (field === 'namePl') setQuestionNamePl(event.target.value);
    if (field === 'nameIt') setQuestionNameIt(event.target.value);
    if (field === 'nameEs') setQuestionNameEs(event.target.value);
    if (field === 'namePt') setQuestionNamePt(event.target.value);

    if (field === 'leadEn') setQuestionLeadEn(event.target.value);
    if (field === 'leadRu') setQuestionLeadRu(event.target.value);
    if (field === 'leadUk') setQuestionLeadUk(event.target.value);
    if (field === 'leadPl') setQuestionLeadPl(event.target.value);
    if (field === 'leadIt') setQuestionLeadIt(event.target.value);
    if (field === 'leadEs') setQuestionLeadEs(event.target.value);
    if (field === 'leadPt') setQuestionLeadPt(event.target.value);
  };

  const selectCategory = (event) => {
    setCategoryUid(event.target.value);
    setCategoryName(event.target.options[event.target.selectedIndex].text);
    setSubcategoryUid('all');
    setSubcategoryName('');
  };

  const selectSubcategory = (event) => {
    setSubcategoryUid(event.target.value);
    setSubcategoryName(event.target.options[event.target.selectedIndex].text);
  };

  const selectTypeImage = (event) => {
    setTypeImage(event.target.value);
  };

  const handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      setImage(image);
    }
  };

  const handleUpload = (id) => {
    const uploadTask = storage.ref(`question/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      error => {
        // Error function ...
        console.log(error);
      },
      () => {
        storage
          .ref("question")
          .child(image.name)
          .getDownloadURL()
          .then((urlResult) => {
            //delete old image
            if (question.image) {
              storage.refFromURL(question.image).delete();
            }
            updateQuestionImage(id, urlResult);
            //update db
            setUrl(urlResult);
          });
      }
    );
  };

  const onClickAnswerSave = () => {
    if (subcategoryUid !== 'all') {
      createAnswer(
        id,
        subcategoryUid,
        isCorrect,
        answerNameEn,
        answerNameRu,
        answerNameUk,
        answerNamePl,
        answerNameIt,
        answerNameEs,
        answerNamePt)
      .then(() => {
        setIsAdd(false);

      //Get answers
      getAnswersListById(id)
        .then((result) => {
          setAnswers(result);
          setIsAdd(true);
          setAnswerNameEn('');
          setAnswerNameRu('');
          setAnswerNameUk('');
          setAnswerNameIt('');
          setAnswerNamePl('');
          setAnswerNameEs('');
          setAnswerNamePt('');
        })
        .catch((error) => {
            console.log('error getAnswersListById', error);
            setAnswers([]);
        });
      })
      .catch((error) => {
        console.log('createAnswer error', error);
      });
    } else {
      alert('Подкатегория должны быть заполнены');
    }
  };

  const onClickAnswerCancel = () => {
    setIsAdd(true);
    setAnswerNameEn('');
    setAnswerNameRu('');
    setAnswerNameUk('');
    setAnswerNameIt('');
    setAnswerNamePl('');
    setAnswerNameEs('');
    setAnswerNamePt('');
  };

  const clickOnAddAnswer = () => {
    setIsAdd(true);
  };

  const checkboxOnChange = (value) => {
    setIsCorrect(!isCorrect);
  };

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="questions" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li>
                  <Link to="/questions">Вопросы</Link>
                </li>
                <li className="active">Вопрос</li>
              </ul>
            </div>
            <div className="page-content">
              <div className="row">
							  <div className="col-xs-12">
                  <div className="row">
								  	<div className="col-xs-12">
                      <div className="row">
                        <div className="col-xs-2">
                          <h2>Вопрос</h2>
                        </div>
                        <div className="col-xs-10">
                        <p className="text-info">
                            * Вопрос может быть с картинкой или без картинки. Картинка может быть в ответе.
                          </p>
                        </div>
                      </div>
                      
										  <table id="simple-table" className="table  table-bordered table-hover">
											  <thead>
                          <tr>
                            <th>Картинка</th>
                            <th>Категория</th>
                            <th>Подкатегория</th>
                            <th>EN</th>
                            <th>RU</th>
                            <th>UK</th>
                            <th>IT</th>
                            <th>PL</th>
                            <th>ES</th>
                            <th>PT</th>
                            <th></th>
                          </tr>
											  </thead>

											  <tbody>
                          <tr>
                            <td>
                              {url && !isEditQuestion ? (<img src={url} alt={question.name.ru} width="100" />) : null}
                              <br />
                              <small>
                                {typeImage === 'answer' ? 'В ответе' : null}
                                {typeImage === 'question' ? 'В вопросе' : null}
                              </small>
                              {isEditQuestion ? (
                              <div>
                                <Select
                                  withAll={true}
                                  items={typeImageArr}
                                  placeholder="Тип отображения картинки"
                                  onChange={(event) => selectTypeImage(event)}
                                  selectedValue={typeImage} index={3}
                                />
                                <br />
                                <br />
                                <progress value={progress} max="100" className="progress" />
                                <br />
                                <label className="ace-file-input">
                                  <input type="file" id="id-input-file-2" onChange={(e) => handleChange(e)} />
                                  <span className="ace-file-container" data-title="Choose">
                                    <span className="ace-file-name" data-title="No File ...">
                                      <i className=" ace-icon fa fa-upload"></i>
                                    </span>
                                  </span>
                                  <button type="button" className="remove">
                                    <i className="ace-icon fa fa-times"></i>
                                  </button>
                                </label>
                                <button type="button" className="btn btn-sm btn-success" onClick={() => handleUpload(id)}>
                                  Загрузить
                                  <i className="ace-icon fa fa-upload icon-on-right bigger-110"></i>
                                </button>
                                <br />
                                <br />
                                {url ? ( <img src={url} alt="Uploaded Images" width="100" />) : null}
                              </div>
                            ) : null}
                            </td>
                            <td>
                              {isEditQuestion ? (
                                <Select
                                  withAll={true}
                                  items={categories}
                                  placeholder="Категории"
                                  onChange={(event) => selectCategory(event)}
                                  selectedValue={categoryUid} index={1}
                                />
                              ) : categoryName}
                            </td>
                            <td>
                            {isEditQuestion ? (
                                <Select
                                  withAll={true}
                                  items={selectedSubcategories}
                                  placeholder="Подкатегории"
                                  onChange={(event) => selectSubcategory(event)}
                                  selectedValue={subcategoryUid}
                                  index={2}
                                />
                              ) : subcategoryName}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-nameEn' }
                                  placeholder="Вопрос (EN)"
                                  value={questionNameEn}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'nameEn')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadEn'}
                                  placeholder="Описание правильного ответа (EN)"
                                  value={questionLeadEn}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadEn')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNameEn}</b>
                                  <br />
                                  <p>{questionLocalLeadEn}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-nameRu' }
                                  placeholder="Вопрос (RU)"
                                  value={questionNameRu}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'nameRu')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadRu'}
                                  placeholder="Описание правильного ответа (RU)"
                                  value={questionLeadRu}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadRu')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNameRu}</b>
                                  <br />
                                  <p>{questionLocalLeadRu}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-nameUk' }
                                  placeholder="Вопрос (UK)"
                                  value={questionNameUk}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'nameUk')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadUk'}
                                  placeholder="Описание правильного ответа (UK)"
                                  value={questionLeadUk}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadUk')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNameUk}</b>
                                  <br />
                                  <p>{questionLocalLeadUk}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-nameIt' }
                                  placeholder="Вопрос (IT)"
                                  value={questionNameIt}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'nameIt')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadIt'}
                                  placeholder="Описание правильного ответа (IT)"
                                  value={questionLeadIt}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadIt')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNameIt}</b>
                                  <br />
                                  <p>{questionLocalLeadIt}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-namePl' }
                                  placeholder="Вопрос (PL)"
                                  value={questionNamePl}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'namePl')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadPl'}
                                  placeholder="Описание правильного ответа (PL)"
                                  value={questionLeadPl}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadPl')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNamePl}</b>
                                  <br />
                                  <p>{questionLocalLeadPl}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-nameEs' }
                                  placeholder="Вопрос (ES)"
                                  value={questionNameEs}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'nameEs')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadEs'}
                                  placeholder="Описание правильного ответа (ES)"
                                  value={questionLeadEs}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadEs')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNameEs}</b>
                                  <br />
                                  <p>{questionLocalLeadEs}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <div>
                                <input
                                  type="text"
                                  id={'form-namePt' }
                                  placeholder="Вопрос (PT)"
                                  value={questionNamePt}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'namePt')}
                                />
                                <br/><br/>
                                <input
                                  type="text"
                                  id={'form-leadPt'}
                                  placeholder="Описание правильного ответа (PT)"
                                  value={questionLeadPt}
                                  className="col-xs-12 col-sm-12"
                                  onChange={(event) => onChangeText(event, 'leadPt')}
                                />
                              </div>
                              ) : (
                                <div>
                                  <b>{questionLocalNamePt}</b>
                                  <br />
                                  <p>{questionLocalLeadPt}</p>
                                </div>
                              )}
                            </td>
                            <td>
                            {isEditQuestion ? (
                              <p>
                                <button className="btn btn-success btn-xs" onClick={() => onClickSave()}>
                                  <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
                                </button>
                                &nbsp;&nbsp;
                                <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
                                  <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
                                </button>
                              </p>
                            ) : (
                              <p>
                                <button className="btn btn-warning btn-xs" onClick={() => onClickEdit()}>
                                  <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
                                </button>
                                &nbsp;&nbsp;
                                <button className="btn btn-grey btn-xs" onClick={() => onClickDelete()}>
                                  <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
                                </button>
                              </p>
                            )}
                            </td>
                          </tr>
                        </tbody>
										  </table>

                      <hr />
                      
                      <div className="row">
                        <div className="col-xs-2">
                          <h2>Ответы</h2>
                        </div>
                        <div className="col-xs-10">
                          <p className="text-info">
                            * Вариантов ответов должно быть 2 или 4. ** Правильный ответ - всего один.
                          </p>
                        </div>
                      </div>

                      {isAdd ? (
                      <div className="row">
                        <div className="col-xs-12">
                          <table id="simple-table" className="table  table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>Правильный?</th>
                                <th>EN</th>
                                <th>RU</th>
                                <th>UK</th>
                                <th>IT</th>
                                <th>PL</th>
                                <th>Es</th>
                                <th>PT</th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>
                                <label>
                                  <input name="switch-field-1" className="ace ace-switch" type="checkbox" value={true} onChange={(value) => checkboxOnChange(value)} checked={isCorrect}  />
                                  <span className="lbl" data-lbl="ДА        НЕТ"></span>
                                </label>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-nameEn'}
                                    placeholder="Ответ (EN)"
                                    value={answerNameEn}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNameEn')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-nameRu'}
                                    placeholder="Ответ (RU)"
                                    value={answerNameRu}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNameRu')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-nameUk'}
                                    placeholder="Ответ (UK)"
                                    value={answerNameUk}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNameUk')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-nameIt'}
                                    placeholder="Ответ (IT)"
                                    value={answerNameIt}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNameIt')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-namePl'}
                                    placeholder="Ответ (PL)"
                                    value={answerNamePl}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNamePl')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-nameEs'}
                                    placeholder="Ответ (ES)"
                                    value={answerNameEs}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNameEs')}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    id={'form-namePt'}
                                    placeholder="Ответ (PT)"
                                    value={answerNamePt}
                                    className="col-xs-12 col-sm-12"
                                    onChange={(event) => onChangeText(event, 'answerNamePt')}
                                  />
                                </td>
                                <td>
                                <button className="btn btn-success btn-xs" onClick={() => onClickAnswerSave()}>
                                  <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
                                </button>
                                &nbsp;&nbsp;
                                <button className="btn btn-grey btn-xs" onClick={() => onClickAnswerCancel()}>
                                  <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
                                </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      <div className="row" style={{marginBottom: 10}}>
                        <div className="col-xs-12 text-right">
                          <button className="btn btn-success" onClick={() => clickOnAddAnswer()}>Добавить ответ</button>
                        </div>
                      </div>
                    )}

                      <div className="row">
                        <div className="col-xs-12">
                          <table id="simple-table" className="table  table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Правильный ответ?</th>
                                <th>Картинка</th>
                                <th>EN</th>
                                <th>RU</th>
                                <th>UK</th>
                                <th>IT</th>
                                <th>PL</th>
                                <th>ES</th>
                                <th>PT</th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody>
                              {answers.map((element, index) => {
                                return <AnswerItem answer={element} key={index} index={index} subcategoryUid={subcategoryUid} />
                              }
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
									  </div>
								  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionPage;
